import type { APIError } from "@/core/services";
import { isRecord, readFirstText } from "./payload";

/**
 * Mensagens por campo (ex.: `janela.saida`) do `details` de um 400 da API, já lido do
 * envelope pelo `http-client`. Aceita mapa ou lista.
 */
export function readErrorDetails(details: unknown): Record<string, string> {
  const result: Record<string, string> = {};

  if (Array.isArray(details)) {
    for (const item of details) {
      if (!isRecord(item)) continue;
      const field = readFirstText(item, "field", "campo", "path").trim();
      const message = readFirstText(item, "message", "mensagem").trim();
      if (field && message) result[field] = message;
    }
  } else if (isRecord(details)) {
    for (const [field, value] of Object.entries(details)) {
      const message = Array.isArray(value) ? String(value[0] ?? "") : String(value ?? "");
      if (message) result[field] = message;
    }
  }

  return result;
}

/** Erro de negócio (ex.: 422) com o código do envelope; `null` quando o erro não traz código. */
export function readBusinessError(error: APIError): { code: string; message: string } | null {
  const code = error.code?.trim();
  return code ? { code, message: error.message.trim() } : null;
}
